<script>
  import { text } from "svelte/internal";
  import { writable } from "svelte/store";
  import { onMount } from "svelte";

  const storedStep = localStorage.getItem("appStep");

  const storedName = localStorage.getItem("name");
  const storedDay1 = localStorage.getItem("day1");
  const storedDay2 = localStorage.getItem("day2");
  const storedDay3 = localStorage.getItem("day3");
  const storedDay4 = localStorage.getItem("day4");
  const storedDay5 = localStorage.getItem("day5");
  const storedDay6 = localStorage.getItem("day6");
  const storedDay7 = localStorage.getItem("day7");

  export const step = writable(storedStep);
  export const name = writable(storedName);
  export const day1 = writable(storedDay1);
  export const day2 = writable(storedDay2);
  export const day3 = writable(storedDay3);
  export const day4 = writable(storedDay4);
  export const day5 = writable(storedDay5);
  export const day6 = writable(storedDay6);
  export const day7 = writable(storedDay7);

  step.subscribe((value) => {
    localStorage.setItem("appStep", value === null ? 1 : value);
  });
  name.subscribe((value) => {
    localStorage.setItem("name", value === null ? "" : value);
  });
  day1.subscribe((value) => {
    localStorage.setItem("day1", value === null ? "" : value);
  });
  day2.subscribe((value) => {
    localStorage.setItem("day2", value === null ? "" : value);
  });
  day3.subscribe((value) => {
    localStorage.setItem("day3", value === null ? "" : value);
  });
  day4.subscribe((value) => {
    localStorage.setItem("day4", value === null ? "" : value);
  });
  day5.subscribe((value) => {
    localStorage.setItem("day5", value === null ? "" : value);
  });
  day6.subscribe((value) => {
    localStorage.setItem("day6", value === null ? "" : value);
  });
  day7.subscribe((value) => {
    localStorage.setItem("day7", value === null ? "" : value);
  });

  let isInWebAppiOS = window.navigator.standalone == true;

  onMount(async () => {
    if (step == null) step.set(1);
  });

  function step1Next(event) {
    if ($name == null || $name.length < 1) {
      alert("Enter your name to continue");
      return;
    }
    step.set(2);
  }

  function email(event) {
    var msg =
      "Click OK to prepopulate an email with your registration details which you can send to your doctor.\n\nYou will be able to check the email before you send it and you will also need to enter your Doctor's email address before sending.";
    if (!confirm(msg)) return;

    var mail = document.createElement("a");

    var subject = "Registration Data for " + $name;
    var body =
      "Patient Name: " + $name + "\n\nThis is my Week 1 registration data:\n\n";
    body = body + "Day 1: " + $day1 + "\n";
    body = body + "Day 2: " + $day2 + "\n";
    body = body + "Day 3: " + $day3 + "\n";
    body = body + "Day 4: " + $day4 + "\n";
    body = body + "Day 5: " + $day5 + "\n";
    body = body + "Day 6: " + $day6 + "\n";
    body = body + "Day 7: " + $day7 + "\n";

    //alert(subject + '\n' + body);

    mail.href =
      "mailto:?body=" + encodeURI(body) + "&subject=" + encodeURI(subject);
    mail.click();
  }

  function print(event) {
    var msg =
      "Click OK to print your registration data.\n\n(Please note: If another confirmation message appears after this one, you may need to tap 'Allow' to continue.)";
    if (!confirm(msg)) return;
    window.print();
  }
</script>

<main>
  <!-- iOS Install Prompt screen -->
  {#if !isInWebAppiOS}
    <div
      class="no-print"
      style="position: fixed; top:0px; left:0px; right:0px; bottom:0px; color:#ffffff; font-weight:bold;">
      <div style="position:relative; top:20%; margin-top:-50px;">
        <div style="color:#ffffff; font-weight:bold; padding-top:3px;">
          Live Without Eczema
        </div>

        <div
          style="color:#ffffff; font-size:30px; font-weight:bold; padding-top:3px;">
          Registration App
        </div>

        <div
          style="color:#ffffff; font-weight:normal; padding-top:18px; padding-left:25px; padding-right:25px;">
          To install this app on your phone:<br />Tap the Share button below,
          <br />
          and then tap <b> "Add to Home Screen"</b>
        </div>
      </div>
    </div>

    <div
      class="no-print"
      style="position: fixed; text-align:center; left:0px; height:120px; right:0px; bottom:0px; color:#ffffff; font-weight:bold;">
      <div
        style="color:#ffffff; font-weight:normal; padding-top:8px; padding-left:25px; padding-right:25px; margin-bottom:20px;">
        Start by tapping the Share button
      </div>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        style="margin-left:auto; margin-right:auto;">
        <title>arrow-down-3</title><g>
          <path
            d="M40,26H31V8A7,7,0,0,0,17,8V26H8a1,1,0,0,0-.765,1.644l16,19a1,1,0,0,0,1.409.121.988.988,0,0,0,.121-.121l16-19A1,1,0,0,0,40,26Z"
            fill="#ffffff" /></g
        ></svg>
    </div>
  {/if}
  <!-- // iOS Install Prompt screen -->

  {#if isInWebAppiOS}
    <div
      class="no-print"
      style="position: fixed; top:0px; left:0px; right:0px; height:40px; color:#ffffff; font-weight:bold; padding-top:3px;">
      Live Without Eczema
    </div>

    {#if $step == null || $step == 1}
      <div
        class="no-print"
        style="position: fixed; top:0px; left:0px; right:0px; bottom:0px; color:#ffffff; font-weight:bold;">
        <div style="position:relative; top:20%; margin-top:-50px;">
          <div
            style="color:#ffffff; font-size:30px; font-weight:bold; padding-top:3px;">
            What's your name?
          </div>

          <div
            style="color:#444; font-weight:normal; padding-top:18px; padding-left:25px; padding-right:25px;">
            <input
              name="name"
              type="text"
              autocomplete="off"
              style="width:100%; height:40px; line-height:40px;font-size:20px; padding-left:5px;"
              bind:value={$name} />
          </div>

          <div
            style="color:#ffffff; font-size:20px; font-weight:bold; padding-top:20px;"
            on:click={step1Next}>
            Next
          </div>
        </div>
      </div>
    {:else}
      <div
        style="position: absolute; top:40px; text-align:left; left:0px; right:0px; bottom:0px; overflow:auto; background-color:#ffffff; padding:20px;">
        <b>REGISTRATION CHART</b>
        <br />
        <b>Week 1: AWARENESS TRAINING</b>
        <br />
        {$name}
        <br />
        <br />

        <style type="text/css">
          .numberBox {
            width: 50px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            text-align: center;
          }
        </style>

        <div style="text-align:center; padding:5px; font-weight:bold;">
          REGISTRATION FOR DAYS 1-7
        </div>

        <table style="width:100%;text-align:center;">
          <tr>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
          </tr>
          <tr>
            <td
              ><input
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                class="numberBox"
                maxlength="4"
                bind:value={$day1} /></td>
            <td
              ><input
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                class="numberBox"
                maxlength="4"
                bind:value={$day2} /></td>
            <td
              ><input
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                class="numberBox"
                maxlength="4"
                bind:value={$day3} /></td>
            <td
              ><input
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                class="numberBox"
                maxlength="4"
                bind:value={$day4} /></td>
            <td
              ><input
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                class="numberBox"
                maxlength="4"
                bind:value={$day5} /></td>
            <td
              ><input
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                class="numberBox"
                maxlength="4"
                bind:value={$day6} /></td>
            <td
              ><input
                type="number"
                inputmode="numeric"
                pattern="[0-9]*"
                class="numberBox"
                maxlength="4"
                bind:value={$day7} /></td>
          </tr>
        </table>
        <br />
        <br />
        <ul style="font-size:12px;" class="no-print">
          <li>Scratching means ALL touching of the skin</li>
          <li>Scratching = Picking = Rubbing = Touching</li>
          <li>Do not avoid scratching</li>
          <li>Allow registration to make you more aware of your habit!</li>
          <li>
            Note below your daily totals and your particularly scratchy
            situations
          </li>
        </ul>
        <div class="no-print">
          <br />
          <br />
          <b>Share with your Doctor</b>
          <br /><br />
          <button style="width:150px;" on:click={print}>Print</button>
          &nbsp;<button style="width:150px;" on:click={email}>Email</button>
        </div>
      </div>
    {/if}
  {/if}
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
